import { i18n } from '@/modules/localization';
export default {
  title: {
    align: 'center',
    style: {
      fontSize: '25px',
    },
  },
  subtitle: {
    align: 'center',
    style: {
      color: '#7c939f',
      fontSize: '24px',
    },
  },
  series: [{
    data: [],
  }],
  xaxis: {
    categories: [],
  },
  yaxis: {
    labels: { show: true },
  },
  chart: {
    type: 'bar',
    foreColor: '#fff',
    height: 400,
    toolbar: { show: false },
    locales: [{
      name: 'pt',
      options: {
        months: [
          'Janeiro',
          'Fevereiro',
          'Março',
          'Abril',
          'Maio',
          'Junho',
          'Julho',
          'Agosto',
          'Setembro',
          'Outubro',
          'Novembro',
          'Dezembro',
        ],
        shortMonths: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        days: [
          'Domingo',
          'Segunda',
          'Terça',
          'Quarta',
          'Quinta',
          'Sexta',
          'Sábado',
        ],
        shortDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        toolbar: {
          exportToSVG: 'Baixar SVG',
          exportToPNG: 'Baixar PNG',
          exportToCSV: 'Baixar CSV',
          menu: 'Menu',
          selection: 'Selecionar',
          selectionZoom: 'Selecionar Zoom',
          zoomIn: 'Aumentar',
          zoomOut: 'Diminuir',
          pan: 'Navegação',
          reset: 'Reiniciar Zoom',
        },
      },
    },
    ],
    defaultLocale: 'pt',
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      horizontal: true,
    },
  },
  fill: { colors: ['#e75e0f'] },
  stroke: { width: 1, colors: ['#fff'] },
  tooltip: {
    followCursor: true,
    theme: 'dark',
    x: { show: false },
    y: {
      formatter: (value) => value,
      title: {
        formatter: (value, opt) => opt.w.globals.labels[opt.dataPointIndex] + ': ',
      },
    },
  },
  noData: {
    text: i18n.global.t('naoForamEncontradasInfosParaOsFiltrosFornecidos'),
    align: 'center',
    verticalAlign: 'middle',
    offsetX: 0,
    offsetY: 0,
  },
};
